module.exports = __webpack_public_path__ + "img/image (8).6b69d4a4.png";